module.exports = __webpack_public_path__ + "media/assets/images/blog/fb-arch-e7dd5f53711ceb72f0b1391ce128ba67.png";